<template>
  <cube-button
    icon="like"
    inline
    primary
  >With-Icon 按钮</cube-button>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({})
</script>

<script type="application/json">
  {
    "usingComponents": {
      "cube-button": "@mpxjs/mpx-cube-ui/src/components/button/index"
    }
  }
</script>
